<template>
    <b-card no-body>
        <!-- Card image -->
        <img class="card-img-top" :src="currentBook.thumb" alt="Image placeholder">
        <!-- Card body -->
        <b-card-body>
            <div class="loader" v-if="loading"></div>
            <b-card-title class="h2 mb-0">{{ getBookTitle() }}</b-card-title>
            <small class="text-muted">
                Your editorial assistant: {{ currentBook.editor }}
                <br>
                Date of last change: {{ formatDate(currentBook.updated_at) }}
            </small>
            <b-card-text class="mt-4">
                <!-- Click here to continue with your Art Book now. -->
                <br>
                Your next step is:
                <br>
                <strong>{{ currentBook.written_next_step }}</strong>
            </b-card-text>
            <a :href="'#/artist/'+currentBook.id+'/wizard'" class="btn btn-sm btn-dark" v-if="mayContinue">Continue Art Book</a>
        </b-card-body>
    </b-card>

</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "current-photo-book",
    data() {
      return {
        loading: false,
        currentBook: [],
      };
    },
    props: {
        photoBookId: '',
    },
    methods: {
      retrieveBook() {
        this.loading = true;
        this.$api.getPhotoBook(this.photoBookId)
          .then((response) => {
            console.log(response);
            this.currentBook = response.data;
            console.log("CurrentBook:"+this.currentBook);
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      formatDate(date) {
        return moment(date).format("Do MMM YYYY")
      },
      getBookTitle() {
        // Check if title exists and is not null/empty
        if (this.currentBook.title && this.currentBook.title.trim() !== '') {
          return `Your Art Book '${this.currentBook.title}'`;
        } else if (this.currentBook.id) {
          // Fallback to ID if available
          return `Your Art Book #${this.currentBook.id}`;
        } else {
          // Final fallback when neither title nor ID is available
          return 'Your Art Book';
        }
      },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        bookLoaded: function () {
            return this.currentBook ? true : false;
        },
        mayContinue(){
        if(this.currentBook.next_step == "7"){
          return false
        }
        if(this.currentBook.next_step == "11"){
          return false
        }
        return true
      }
  },
    mounted() {
        this.retrieveBook();
    },
};
</script>
<style></style>